import { useEffect, useState, useRef } from 'react';

import { isChrome, isSafari } from '@confluence/browser-helper';

const applyDefaultWidth = () => {
	const editorScrollParent: HTMLElement | null = document.querySelector(
		'.fabric-editor-popup-scroll-parent',
	);
	if (editorScrollParent) {
		return editorScrollParent.clientWidth || 0;
	}
	return 0;
};

export const useEditorWidthObserver = () => {
	const defaultWidth = applyDefaultWidth();
	const [width, setWidth] = useState<any>(defaultWidth);
	const [leftOffset, setLeftOffset] = useState<number>(0);
	const observerRef = useRef<ResizeObserver | null>(null);

	useEffect(() => {
		const editorScrollParent: HTMLElement | null = document.querySelector(
			'.fabric-editor-popup-scroll-parent',
		);
		if (editorScrollParent) {
			observerRef.current = new ResizeObserver((entries) => {
				// webkitbrowsers add a scroll padding that pushes content around
				if (isChrome() || isSafari()) {
					const innerWidth = Math.floor(entries[0]?.target.clientWidth);
					const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
					if (outerWidth > innerWidth) {
						setLeftOffset(outerWidth - innerWidth);
					}
				}

				setWidth(Math.floor(entries[0]?.target.clientWidth) - leftOffset);
			});
			observerRef.current.observe(editorScrollParent);

			return () => observerRef?.current?.disconnect();
		}
	}, [observerRef, leftOffset]);

	return {
		width,
		observerRef: observerRef.current,
		leftOffset,
	};
};
